export default __webpack_public_path__ + "static/media/envlope.be838312.svg";